module.exports = __webpack_public_path__ + "img/align_circle.59b46617.svg";